import { z } from "zod";

/**
 * Validação sem compilar funções (F35). O zod decide, ao definir cada schema, se vai acelerar
 * objetos com `new Function`, e uma CSP sem `unsafe-eval` reporta até a tentativa engolida. O
 * cliente importa este módulo antes de tudo (antes dos schemas); o servidor, sem CSP, não importa e
 * mantém a validação rápida.
 */
z.config({ jitless: true });
